import { SHIPPING_TYPES } from '@customink/project-service-types';

import { useBssEligibility } from '@/hooks/Project/useBssEligibility';

/**
 * Distributed shipping will utilize Bulk Split Shipping (BSS)
 */
export const useDistributedShipStrategy = () => {
  const [
    { isEligibleBSS, ineligibleReason, isSelfService },
    { isFetching, isLoading },
  ] = useBssEligibility();

  return [
    {
      ineligibleReason,
      isEligible: isEligibleBSS,
      isSelfService,
      shippingType: isEligibleBSS ? SHIPPING_TYPES.INDIVIDUAL : null,
    },
    {
      isFetching,
      isLoading,
    },
  ] as const;
};
